import { KEY_SEPARATOR } from '../crypto-utils';
import {
  toAESKey,
  decryptAES,
  generateRandomAESKey,
  encryptAES,
  exportAESKey,
} from './aes-utils';
import { decryptRSA, encryptRSA } from './rsa-utils';

export const decryptPrivateKey = async (
  encryptedContent: string,
  privateKey: Uint8Array
) => {
  const [encryptedAesKey, encryptedPrivateKey] =
    encryptedContent.split(KEY_SEPARATOR);

  if (!encryptedAesKey || !encryptedPrivateKey)
    throw new Error('Invalid encrypted content');

  const aesKeyBytes = await decryptRSA(encryptedAesKey, privateKey);

  const aesKey = await toAESKey(aesKeyBytes);

  return await decryptAES(encryptedPrivateKey, aesKey);
};

export const encryptPrivateKey = async (
  keyToEncrypt: Uint8Array,
  publicKey: Uint8Array
) => {
  const aesKey = await generateRandomAESKey();
  const encryptedPrivateKey = await encryptAES(keyToEncrypt, aesKey);
  const exportedAesKey = await exportAESKey(aesKey);
  const encryptedAesKey = await encryptRSA(exportedAesKey, publicKey);

  return encryptedAesKey + KEY_SEPARATOR + encryptedPrivateKey;
};
